const defaultBoxes = [];
const allBoxes = (state = defaultBoxes, action) => {
  switch (action.type) {
    case 'EPIK_BOXES_CLEAR':
      return defaultBoxes;
    case 'ALL_EPIK_BOXES_SUCCESS':
      return [...action.allBoxes];
    default:
      return state;
  }
};

export default allBoxes;
